import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';

interface AdminUserLinkProps {
  userId: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * A component that renders a user name as a clickable link for admins.
 * Non-admins see plain text, admins see a link to the admin user panel.
 */
export function AdminUserLink({ userId, children, className }: AdminUserLinkProps) {
  const { user, isAuthenticated } = useAuth();
  const isAdmin = isAuthenticated && user?.isAdmin;

  if (!isAdmin) {
    return <span className={className}>{children}</span>;
  }

  return (
    <Link
      to={`/admin/users?userId=${userId}`}
      className={cn(
        'hover:underline hover:text-primary transition-colors',
        className
      )}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </Link>
  );
}
